// extracted by mini-css-extract-plugin
export var faqContainer = "faq-module--faqContainer--13f1e";
export var moduleContainer = "faq-module--moduleContainer--0f0bf";